import { render, staticRenderFns } from "./TitleDesign.vue?vue&type=template&id=44e40e93&"
import script from "./TitleDesign.vue?vue&type=script&lang=js&"
export * from "./TitleDesign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports